// The mobile layouts a drop card grid can be shown in, picked per grid in
// Directus through its `variants` checkboxes. Tablet and desktop always keep
// the original layout.
export const DropCardVariant = Object.freeze({
	// The cards as designed: one per row on mobile, every detail on the card.
	Original: 'original',
	// Design A: two compact cards per row on mobile.
	Grid: 'grid',
	// Design B: one compact row per card on mobile, a thumbnail beside the text.
	List: 'list',
});

export type DropCardVariant =
	(typeof DropCardVariant)[keyof typeof DropCardVariant];

// The A/B assignment written by the inline script in `src/app.html`, which
// cannot import this file: keep both in step. The cookie holds a random
// bucket that the script also reduces to an arm index per arm count, on the
// root element, so CSS can show the visitor's arm before the first paint.
export const DROP_AB_COOKIE = 'heni_ab';
export const DROP_AB_BUCKET_ATTRIBUTE = 'data-ab-bucket';
export const DROP_AB_MAX_ARMS = 3;
